import {$regraAcao, $regraEntidade} from "@/custom-enum/regras-enum";

export default [
    {
        path: '/cadastro-modulos',
        name: 'cadastro-modulos',
        meta: {
            resource: $regraEntidade.rotas.protegida,
            subject: $regraEntidade.menuLateral.modulos.modulo,
            action: $regraAcao.visualizar,
            layout: 'normal',
            title: 'Cadastro de módulos'
        },
        component: () => import ('@/views/pages/modulo/InserirModulo')
    },
    {
        path: '/listagem-modulos',
        name: 'listar-modulos',
        meta: {
            resource: $regraEntidade.rotas.protegida,
            subject: $regraEntidade.menuLateral.modulos.modulo,
            action: $regraAcao.visualizar,
            layout: 'normal',
            title: 'Editar módulos'
        },
        component: () => import ('@/views/pages/modulo/ListagemModulos.vue'),
    }
]
